import { IconButton, Typography } from '@one-thd/sui-atomic-components';
import { Location, OrderTracking } from '@one-thd/sui-icons';
import React from 'react';
import { dateFormat, formatCityState, timeFormat } from '../util/format';
var TrackShipmentDetails = function (_a) {
    var shipmentTrackingDetail = _a.shipmentTrackingDetail;
    var _b = shipmentTrackingDetail, _c = _b.trackingNo, trackingNo = _c === void 0 ? '' : _c, _d = _b.providerName, providerName = _d === void 0 ? '' : _d, _e = _b.currentShipStatus, currentShipStatus = _e === void 0 ? '' : _e, _f = _b.deliveredDate, deliveredDate = _f === void 0 ? '' : _f, _g = _b.estimatedDeliveryDate, estimatedDeliveryDate = _g === void 0 ? '' : _g, eventDetails = _b.eventDetails;
    var trackingEvent = eventDetails.trackingEvent;
    var deliveryDate = deliveredDate || estimatedDeliveryDate;
    var formatDate = 'LLL dd';
    var trackingHistory = trackingEvent.map(function (trackEvent, i) {
        var _a = trackEvent, address = _a.address, eventDetail = _a.eventDetail, date = _a.date, time = _a.time;
        if (!eventDetail) {
            return null;
        }
        var key = "tracking-event-".concat(i);
        var eventDetailUpper = eventDetail.toUpperCase();
        var iconImage = ['DELIVERED', 'DELIVERED.'].includes(eventDetailUpper)
            ? Location
            : OrderTracking;
        return (React.createElement("div", { key: key },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-text-align " },
                React.createElement("div", { className: "sui-flex sui-flex-row sui-w-1/3 sui-self-center " },
                    React.createElement(IconButton, { icon: iconImage, "data-automation-id": "trackingEventIcon".concat(i) }),
                    React.createElement("div", { className: "sui-flex sui-flex-col" },
                        React.createElement(Typography, { "data-automation-id": "trackingEventDate".concat(i) }, dateFormat(date, formatDate)),
                        React.createElement(Typography, { "data-automation-id": "trackingEventTime".concat(i) }, timeFormat(time)))),
                React.createElement("div", { "data-automation-id": "trackingEventLocation".concat(i), className: "sui-self-center sui-w-1/3" }, formatCityState(address)),
                React.createElement("div", { "data-automation-id": "trackingEventDetail".concat(i), className: "sui-self-center sui-w-1/3" }, eventDetail)),
            React.createElement("hr", null)));
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex sui-flex-col sui-my-4" },
            React.createElement(Typography, { weight: "bold", "data-test-id": "delivery-text" }, deliveredDate ? 'Delivered On' : 'Estimated Delivery'),
            React.createElement(Typography, null, dateFormat(deliveryDate, formatDate))),
        React.createElement("div", { className: "sui-flex sui-flex-row sui-gap-4 sui-my-4" },
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, { weight: "bold" }, "Status"),
                React.createElement(Typography, null, currentShipStatus)),
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, { weight: "bold" }, "Tracking Number"),
                React.createElement(Typography, { "date-test-id": "tracking-number-value" }, trackingNo)),
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, { weight: "bold" }, "Shipping Provider"),
                React.createElement(Typography, { "date-test-id": "provider-name-value" }, providerName))),
        React.createElement(Typography, null, "Tracking History"),
        " ",
        React.createElement("hr", null),
        trackingHistory));
};
export default TrackShipmentDetails;
